// @core/api/endpoints/workflow/update_node_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NodeTypeResponse,
  UpdateNodeTypeRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update node type
 * Updates a node type's configuration, schema, or visual properties.
 */
export async function UpdateNodeType(
  node_type_id: string,
  data: UpdateNodeTypeRequest,
  options?: RequestOptions
): Promise<NodeTypeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/node-types/:node_type_id`;
  requestPath = requestPath.replace(':node_type_id', encodeURIComponent(node_type_id));
  const requestOptions = options;
  return client.put<NodeTypeResponse>(requestPath, data, requestOptions);
}
